module.exports = __webpack_public_path__ + "static/media/51.2b31b1e5.png";